import { Loader } from 'ui/loader';
import { Switch } from 'ui/switch';

import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import { ViewWrapper } from 'components/partials/insight-modal/shared/components';
import { useUserAccess } from 'components/partials/insight-modal/components/user-access-step/hooks/use-user-access';
import { getInsightUsersTableSettings } from 'components/partials/insight-modal/components/user-access-step/user-access-step.config';

interface UserAccessStepProps {
  onUsersChange?: (
    assignedUsers: Array<{ userId: string | number; hasAccess: boolean }>
  ) => void;
}

const UserAccessStep = ({ onUsersChange }: UserAccessStepProps) => {
  const {
    loading,
    displayedData,
    isAllUsersSelected,
    isIndeterminate,
    isToggleOn,
    onSelectAllUsers,
    onUserChange,
    onToggleChange,
  } = useUserAccess({ onUsersChange });

  const columns = getInsightUsersTableSettings({
    onUserChange,
    onSelectAllUsers,
    isAllUsersSelected,
    isIndeterminate,
  });

  if (loading && !displayedData.length) {
    return (
      <ViewWrapper>
        <Loader loading={true} backdrop="white" fullScreen={false} />
      </ViewWrapper>
    );
  }

  if (!displayedData.length && !loading) {
    return (
      <ViewWrapper>
        <EmptySpaceContent
          customClass="h-[55vh]"
          text="No users have been assigned yet"
        />
      </ViewWrapper>
    );
  }

  return (
    <ViewWrapper>
      <div className="relative">
        <TableComponent
          columns={columns}
          data={displayedData}
          customHeight="max-h-96"
          isLoading={loading}
          pagination={false}
          showingRecordsTextIsOn={false}
          viewByAmountSelectIsOn={false}
        />

        <div className="flex items-center justify-start mt-4">
          <Switch
            label="Assign to all new users"
            checked={isToggleOn}
            onChange={(_event, checked) => onToggleChange(checked)}
            data-testid="user-access-step-toggle"
          />
        </div>
      </div>
    </ViewWrapper>
  );
};

export default UserAccessStep;
